// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"a7e1a881","787":"4fa97fec","834":"e3fd92c0"}[chunkId] + ".chunk.js";
};